import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import { checkLogin } from "features/common/auth/authSlice";
import DomainBackorder from "pages/Domain/DomainBackorder";
import OtherProduct from "pages/OtherProduct";
import PageError from "pages/PageError";
import PaymentMethod from "pages/PaymentMethod";
import Summary from "pages/Summary";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import persistStore from "redux-persist/es/persistStore";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { store } from "./app/store";
import "./assets/css/customize-component.css";
import "./assets/css/main.css";
import Domain from "./pages/Domain";
import Hosting from "./pages/Hosting";
import Vps from "./pages/VPS";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
      errorElement: <PageError />,
    },
    {
      path: "orderhosting",
      element: <Hosting />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderdomain",
      element: <Domain />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderdomainbackorder",
      element: <DomainBackorder />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderserver",
      element: <Vps />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "ordersummary",
      element: <Summary />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "paymentmethod",
      element: <PaymentMethod />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderproduct",
      element: <OtherProduct />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "migrasihosting",
      element: <Hosting />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "*",
      element: <PageError />,
    },
  ],
  {
    basename: process.env.REACT_APP_BASE_PATH,
  }
);

const container = document.getElementById("root");
const root = createRoot(container);

let persistor = persistStore(store);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <RouterProvider router={router} />
    </PersistGate>
  </Provider>
);

// Skip auth check for development or when explicitly disabled
const skipAuthCheck = process.env.NODE_ENV === "development" || 
                     process.env.REACT_APP_SKIP_AUTH === "true";

if (!skipAuthCheck) {
  store.dispatch(checkLogin());
}
